export default {

  // form and basics
  login: 'Login',
  add: 'Add',
  save: 'Save',
  done: 'Done',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  back: 'Back',
  name: 'Name',
  username: 'Username',
  email: 'Email',
  phone: 'Phone',
  password: 'Password',
  oldPassword: 'Old password',
  newPassword: 'New password',
  accountStatus: 'Account status',
  search: 'Search',
  choose: 'Choose...',
  active: 'Active',
  disactive: 'Disactive',
  allRightsRecieved: 'All Rights Recieved',

  // success messages
  savedMessage: 'Saved successfully',

  // error messages
  errorMessage: 'Error',

  // required messages
  nameRequired: 'Name is required',
  usernameRequired: 'Username is required',
  emailRequired: 'Email is required',
  emailValidRequired: 'Email is not valid',
  phoneRequired: 'Phone is required',
  phoneLengthRequired: 'Phone is 11 number',
  passwordRequired: 'Password is required',
  passwordLengthRequired: "Password more than 8 character",
  accountStatusRequired: 'Account status is required',
  userOrPasswordWrong: 'Wrong username or password',

  // side nav
  homepage: 'Homepage',
  settings: 'Settings',
  
  // products
  products: 'Products',

  // articles
  articles: 'Articles',


};